module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAOCAYAAAD0f5bSAAAAAXNSR0IArs4c6QAAAVpJREFUKFON0rFLW1EUx/HveZCQJTjETfwDRBS6dKngJlLo4lCF0vVcC3a3YxdFLbTg9M4jJbjYoYNO7eDi6uQiKOrSDg4pIbQI8UXead6QEOSZ9i4HLnzOvZzzE1VVYB2o8vjJgLM0TZ83Go2OqOo10HT3ryPQuIgE4JOZvc9RDrba7fbHWq02+RB2u93f9Xq9parnwKmZrQxQFEVVd39X8FrTzCYKUaVS2e10OlMPkYi0zOxHIQK+icgqIMCRmR0MN1DVY3f/niTJ5uB7InILvAEyETmJ41hDCItZlj3tYxH5UyqV9gYoSZIPw51DCG/dfRu4G7ovA1ePIlXdB2bTNH3WR+VyeQNYGoW+ANNmNtNHIYQdd3/9T9QbyhzwWUQOgZn/QU+Ae6C/9BtgrDBGURRduPsrYBn46e55hNZEZKFXf+WoKLBtIB/ECxF5GcfxZb4/Vd0F5v8CjWTS7W5Kv0EAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/menus_icon/gyskh.png
// module id = +rhi
// module chunks = 3